
import login from '../views/login.vue'
// import login = () => import(/* webpackChunkName: "login" */ '../views/login.vue')
import index from '../views/index.vue'
import index_content from '../views/index_content.vue'

/*
 * 销售
 */
// 订单列表
import order_list from '../views/sale_manage/order_list.vue'
// 账单列表
import bill_list from '../views/sale_manage/bill_list.vue'
// 预定单列表
import book_order from '../views/sale_manage/book_order.vue'
// 支付流水
import pay_flow from '../views/sale_manage/pay_flow.vue'
// 预定列表
import book_list from '../views/sale_manage/book_list.vue'

/*
 * 商品管理
 */
// 商品列表
import commodity_list from '../views/commodity_manage/commodity_list.vue'
// 商品套餐列表
import commodity_package_list from '../views/commodity_manage/commodity_package_list.vue'
// 商品配送
import commodity_distribt from '../views/commodity_manage/commodity_distribt.vue'
// 开房套餐名称
import package_name from '../views/commodity_manage/package_name.vue'
// 开房套餐价格
import package_price from '../views/commodity_manage/package_price.vue'
// 计时开房列表
import timing_package from '../views/commodity_manage/timing_package.vue'
// 不满一小时按小时算
import setting_package from '../views/commodity_manage/setting_package.vue'
// 开房小吃
import commodity_snack from '../views/commodity_manage/commodity_snack.vue'
// 价格策略
import price_strategy from '../views/commodity_manage/price_strategy.vue'
// 积分兑换
import point_exchange from '../views/commodity_manage/point_exchange.vue'
// 自助大厅轮播设置
import self_roll_set from '../views/commodity_manage/self_roll_set.vue'
// 商品免单规则设置
import commodity_free_rule from '../views/commodity_manage/commodity_free_rule.vue'
// 花管理
import flower_manage from '../views/commodity_manage/flower_manage.vue'
// 首次下单必点商品设置
import commodity_must_order from '../views/commodity_manage/commodity_must_order.vue'

/*
 * 仓库管理
 */
// 仓库管理
import store_getStoreList from '../views/stock_management/store_getStoreList.vue'
// 出品台管理
import store_getStoreProduceList from '../views/stock_management/store_getStoreProduceList.vue'
// 供应商管理
import supplier_management from '../views/stock_management/supplier_management.vue'
// 采购进货
import purchasing from '../views/stock_management/purchasing.vue'
// 采购退货
import procurement_return from '../views/stock_management/procurement_return.vue'
// 库存调拨
import stock_getExchangeStockList from '../views/stock_management/stock_getExchangeStockList.vue'
// 报损单
import reported_loss from '../views/stock_management/reported_loss.vue'
// 领用单
import stock_receipts from '../views/stock_management/stock_receipts.vue'
// 仓库盘点
import stock_checks from '../views/stock_management/stock_checks.vue'
// 实时库存
import actual_stock from '../views/stock_management/actual_stock.vue'
// 寄存管理
import deposit_manage from '../views/stock_management/deposit_manage.vue'
// 库存不足是否出货
import shipment_set from '../views/stock_management/shipment_set.vue'

/*
 * 报表
 */
// 营业报表 business_report
import zm_report from '../views/finance_report/business_report/zm_report.vue'
import zh_report from '../views/finance_report/business_report/zh_report.vue'
import dm_report from '../views/finance_report/business_report/dm_report.vue'
import dh_report from '../views/finance_report/business_report/dh_report.vue'
import ys_report from '../views/finance_report/business_report/ys_report.vue'
import xy_report from '../views/finance_report/business_report/xy_report.vue'
import jls_report from '../views/finance_report/business_report/jls_report.vue'
import jld_report from '../views/finance_report/business_report/jld_report.vue'
import sjm_report from '../views/finance_report/business_report/sjm_report.vue'
import sjh_report from '../views/finance_report/business_report/sjh_report.vue'
import gzm_report from '../views/finance_report/business_report/gzm_report.vue'
import dym_report from '../views/finance_report/business_report/dym_report.vue'
import dyh_report from '../views/finance_report/business_report/dyh_report.vue'
import bxf_report from '../views/finance_report/business_report/bxf_report.vue'
import balance_report from '../views/finance_report/business_report/balance_report.vue'
import timefee_detail_report from '../views/finance_report/business_report/timefee_detail_report.vue'
import wine_servicefee_report from '../views/finance_report/business_report/wine_servicefee_report.vue'
import balance_business_report from '../views/finance_report/business_report/balance_business_report.vue'
import zxm_report from '../views/finance_report/business_report/zxm_report.vue'
import business_income_day_report from '../views/finance_report/business_report/business_income_day_report.vue'

// 仓库报表 store_report
import sr_ksm_report from '../views/finance_report/store_report/sr_ksm_report.vue'
import sr_ksh_report from '../views/finance_report/store_report/sr_ksh_report.vue'
import sr_cgm_report from '../views/finance_report/store_report/sr_cgm_report.vue'
import sr_cgh_report from '../views/finance_report/store_report/sr_cgh_report.vue'
import sr_sym_report from '../views/finance_report/store_report/sr_sym_report.vue'
import sr_syh_report from '../views/finance_report/store_report/sr_syh_report.vue'
import sr_jxc_report from '../views/finance_report/store_report/sr_jxc_report.vue'
import sr_pxm_report from '../views/finance_report/store_report/sr_pxm_report.vue'
// 会员报表 member_report
import mr_hcz_report from '../views/finance_report/member_report/mr_hcz_report.vue'
import mr_hbf_report from '../views/finance_report/member_report/mr_hbf_report.vue'
import mr_hzl_report from '../views/finance_report/member_report/mr_hzl_report.vue'
import mr_hkb_report from '../views/finance_report/member_report/mr_hkb_report.vue'
import mr_hxm_report from '../views/finance_report/member_report/mr_hxm_report.vue'
import mr_hsr_report from '../views/finance_report/member_report/mr_hsr_report.vue'
import mr_yhx_report from '../views/finance_report/member_report/mr_yhx_report.vue'
import mr_hcx_report from '../views/finance_report/member_report/mr_hcx_report.vue'
import mr_hjm_report from '../views/finance_report/member_report/mr_hjm_report.vue'
import mr_hjh_report from '../views/finance_report/member_report/mr_hjh_report.vue'
import mr_ggzl_report from '../views/finance_report/member_report/mr_ggzl_report.vue'
import mr_ggky_report from '../views/finance_report/member_report/mr_ggky_report.vue'
import mr_ggfm_report from '../views/finance_report/member_report/mr_ggfm_report.vue'
import mr_ggtm_report from '../views/finance_report/member_report/mr_ggtm_report.vue'
import mr_hjlm_report from '../views/finance_report/member_report/mr_hjlm_report.vue'
import mr_hjltm_report from '../views/finance_report/member_report/mr_hjltm_report.vue'
import mr_hlbgx_report from '../views/finance_report/member_report/mr_hlbgx_report.vue'
import mr_yejz_report from '../views/finance_report/member_report/mr_yejz_report.vue'
import mr_level_change_report from '../views/finance_report/member_report/mr_level_change_report.vue'				
// 酒水存取报表 Wine_access_report
import war_jcm_report from '../views/finance_report/Wine_access_report/war_jcm_report.vue'
import war_jch_report from '../views/finance_report/Wine_access_report/war_jch_report.vue'
import war_qjm_report from '../views/finance_report/Wine_access_report/war_qjm_report.vue'
import war_qjh_report from '../views/finance_report/Wine_access_report/war_qjh_report.vue'
import war_cgm_report from '../views/finance_report/Wine_access_report/war_cgm_report.vue'
import war_cgh_report from '../views/finance_report/Wine_access_report/war_cgh_report.vue'
import war_cqh_report from '../views/finance_report/Wine_access_report/war_cqh_report.vue'
import war_jcj_report from '../views/finance_report/Wine_access_report/war_jcj_report.vue'
import war_yqh_report from '../views/finance_report/Wine_access_report/war_yqh_report.vue'
import war_jczfm_report from '../views/finance_report/Wine_access_report/war_jczfm_report.vue'
// 商品销售报表 goods_sales_report
import gsr_sxm_report from '../views/finance_report/goods_sales_report/gsr_sxm_report.vue'
import gsr_sxh_report from '../views/finance_report/goods_sales_report/gsr_sxh_report.vue'
import gsr_stm_report from '../views/finance_report/goods_sales_report/gsr_stm_report.vue'
import gsr_sth_report from '../views/finance_report/goods_sales_report/gsr_sth_report.vue'
import gsr_szh_report from '../views/finance_report/goods_sales_report/gsr_szh_report.vue'
import gsr_stxm_report from '../views/finance_report/goods_sales_report/gsr_stxm_report.vue'
import gsr_stxh_report from '../views/finance_report/goods_sales_report/gsr_stxh_report.vue'
import gsr_ttxm_report from '../views/finance_report/goods_sales_report/gsr_ttxm_report.vue'
import gsr_ttxh_report from '../views/finance_report/goods_sales_report/gsr_ttxh_report.vue'
import gsr_szm_report from '../views/finance_report/goods_sales_report/gsr_szm_report.vue'
import gsr_cph_report from '../views/finance_report/goods_sales_report/gsr_cph_report.vue'
import gsr_ktxm_report from '../views/finance_report/goods_sales_report/gsr_ktxm_report.vue'
import gsr_ktxh_report from '../views/finance_report/goods_sales_report/gsr_ktxh_report.vue'
import gsr_smzm_report from '../views/finance_report/goods_sales_report/gsr_smzm_report.vue'
// 艺人报表 waiter_report
import wr_ytkm_report from '../views/finance_report/waiter_report/wr_ytkm_report.vue'
import wr_ytc_report from '../views/finance_report/waiter_report/wr_ytc_report.vue'
import wr_ytlh_report from '../views/finance_report/waiter_report/wr_ytlh_report.vue'
import wr_ybm_report from '../views/finance_report/waiter_report/wr_ybm_report.vue'
import wr_ybh_report from '../views/finance_report/waiter_report/wr_ybh_report.vue'
import wr_ydm_report from '../views/finance_report/waiter_report/wr_ydm_report.vue'
import wr_ydh_report from '../views/finance_report/waiter_report/wr_ydh_report.vue'
import wr_yzl_report from '../views/finance_report/waiter_report/wr_yzl_report.vue'
import wr_ytpgm_report from '../views/finance_report/waiter_report/wr_ytpgm_report.vue'
import wr_ytpsm_report from '../views/finance_report/waiter_report/wr_ytpsm_report.vue'
// 其他报表 others_report
import or_hf_report from '../views/finance_report/others_report/or_hf_report.vue'
import or_xld_report from '../views/finance_report/others_report/or_xld_report.vue'
import or_kj_report from '../views/finance_report/others_report/or_kj_report.vue'
import or_yg_report from '../views/finance_report/others_report/or_yg_report.vue'
import or_fp_report from '../views/finance_report/others_report/or_fp_report.vue'
import or_nff_report from '../views/finance_report/others_report/or_nff_report.vue'
import or_kq_report from '../views/finance_report/others_report/or_kq_report.vue'
import or_gdh_report from '../views/finance_report/others_report/or_gdh_report.vue'
import or_yxsm_report from '../views/finance_report/others_report/or_yxsm_report.vue'
import or_jfdhm_report from '../views/finance_report/others_report/or_jfdhm_report.vue'
import or_jfdhh_report from '../views/finance_report/others_report/or_jfdhh_report.vue'
import or_kyjs_report from '../views/finance_report/others_report/or_kyjs_report.vue'
import or_bpsm_report from '../views/finance_report/others_report/or_bpsm_report.vue'
import or_dxfm_report from '../views/finance_report/others_report/or_dxfm_report.vue'
import or_treasure_report from '../views/finance_report/others_report/or_treasure_report.vue'
import or_wx_login_report from '../views/finance_report/others_report/or_wx_login_report.vue'
import or_song_month_report from '../views/finance_report/others_report/or_song_month_report.vue'
// 花单报表 flower_report
import flower_detail_report from '../views/finance_report/flower_report/flower_detail_report.vue'
import flower_total_report from '../views/finance_report/flower_report/flower_total_report.vue'
// 商品盈利报表
import profit_detail_report from '../views/finance_report/goods_profit_report/profit_detail_report.vue'
import profit_total_report from '../views/finance_report/goods_profit_report/profit_total_report.vue'
import goodspackage_detail_report from '../views/finance_report/goods_profit_report/goodspackage_detail_report.vue'
import goodspackage_total_report from '../views/finance_report/goods_profit_report/goodspackage_total_report.vue'
import kfpackage_detail_report from '../views/finance_report/goods_profit_report/kfpackage_detail_report.vue'
import kfpackage_total_report from '../views/finance_report/goods_profit_report/kfpackage_total_report.vue'
// 门票营业报表 ticket_sales_report
import tsr_mym_report from '../views/finance_report/ticket_sales_report/tsr_mym_report.vue'
import tsr_myh_report from '../views/finance_report/ticket_sales_report/tsr_myh_report.vue'
import tsr_gyh_report from '../views/finance_report/ticket_sales_report/tsr_gyh_report.vue'
import tsr_pyh_report from '../views/finance_report/ticket_sales_report/tsr_pyh_report.vue'
import tsr_tjsh_report from '../views/finance_report/ticket_sales_report/tsr_tjsh_report.vue'
// 客戶報表
import customer_data_report from '../views/finance_report/customer_report/customer_data_report.vue'
import report_system_index from '../views/finance_report/customer_report/report_system_index.vue'
// 自助营业额报表
import turnover_report from '../views/finance_report/self-service_business_report/turnover_report.vue'
// 自助营业收入报表
import operating_revenue_report from '../views/finance_report/self-service_business_report/operating_revenue_report.vue'

/*
 * 员工管理
 */
// 员工列表
import employee_list from '../views/staff_manage/employee_list.vue'
// 艺人列表
import waiter_list from '../views/staff_manage/waiter_list.vue'

/*
 * 设置
 */
// 门店列表
import store_list from '../views/system_set/store_list.vue'
// 门店设置
import store_set from '../views/system_set/store_set.vue'
import store_set_business from '../views/system_set/store_set/store_set_business.vue'
import store_set_bill from '../views/system_set/store_set/store_set_bill.vue'
import store_set_deposit from '../views/system_set/store_set/store_set_deposit.vue'
import store_set_vod from '../views/system_set/store_set/store_set_vod.vue'
import store_set_store from '../views/system_set/store_set/store_set_store.vue'
import store_set_print from '../views/system_set/store_set/store_set_print.vue'
import store_set_personnel from '../views/system_set/store_set/store_set_personnel.vue'
import store_set_system from '../views/system_set/store_set/store_set_system.vue'
// 打印机设置
import printer_list from '../views/system_set/printer_list.vue'
// 抹零设置
import moling_set from '../views/system_set/moling_set.vue'
// 抹零设置2
import zero_set from '../views/system_set/zero_set.vue'
// 走马灯设置
import zoumadeng_set from '../views/system_set/zoumadeng_set.vue'
// 会员发送信息设置
import members_send_info_set from '../views/system_set/members_send_info_set.vue'
// 轮播歌曲设置
import set_rotation_song from '../views/system_set/set_rotation_song.vue'
// vod在线设置
import vod_online_set from '../views/system_set/vod_online_set.vue'
// 寄存设置
import deposit_set from '../views/system_set/deposit_set.vue'
// 曲库管理设置
import music_set from '../views/system_set/music_set.vue'
// 收银机设置
import cash_register_set from '../views/system_set/cash_register_set.vue'
// 影片管理
import movie_manage from '../views/system_set/movie_manage.vue'
// 退款退货审批
import refund_check from '../views/system_set/refund_check.vue'
// 商品赠送审批设置
import present_check from '../views/system_set/present_check.vue'
// 缺歌反馈
import lack_song_set from '../views/system_set/lack_song_set.vue'
// 包厢类型设置
import room_type_set from '../views/system_set/room_type_set.vue'
// 欢迎词设置
import welcome_template from '../views/system_set/welcome_template.vue'
// 报修审批设置
import repair_check from '../views/system_set/repair_check.vue'
// 主题菜单歌曲设置
import theme_menu_song from '../views/system_set/theme_menu_song.vue'
// 互动广场广告位设置
import ad_space_set from '../views/system_set/ad_space_set.vue'
// 股东沙龙设置
import vip_salon from '../views/system_set/vip_salon.vue'
// 平板点歌app设置
import pad_order_set from '../views/system_set/pad_order_set.vue'
// 自定义曲库管理
import custom_music_manage from '../views/system_set/custom_music_manage'
// 点歌屏广告位设置
import screen_ad_set from '../views/system_set/screen_ad_set'
// 门牌机自定义设置
import door_plate_set from '../views/system_set/door_plate_set'
// 客遗酒水回收入库审批设置
import guest_leave_store_apply_set from '../views/system_set/guest_leave_store_apply_set'
// 包厢赠送比例设置
import room_give_rule_set from '../views/system_set/room_give_rule_set'
// 福利活动设置
import welfare_activity from "../views/system_set/welfare_activity.vue"
// 公众号点单首页设置
import wx_order_home from "../views/system_set/wx_order_home.vue";
// 业绩系数设置
import performance_set from "../views/system_set/performance_set.vue";
// 团购管理
import group_manage from "../views/system_set/group_manage.vue";

/*
 * 套账
 */
// 套账制作
import account_book_make from '../views/account_book/account_book_make.vue'
// 套账查看
import account_book_report from '../views/account_book/account_book_report.vue'
// 套账打印机设置
import account_book_printer from '../views/account_book/account_book_printer.vue'

/*
 * 门票
 */
// 门票管理
import ticket_manage from '../views/ticket_system/ticket_manage.vue'
// 设置
import bistro_set from "../views/ticket_system/bistro_set.vue"
// 关卡管理
import level_manage from "../views/ticket_system/level_manage.vue"
// 赛事评选
import race_manage from "../views/ticket_system/race_manage.vue"
// 闸机管理
import turnstile_manage from "../views/ticket_system/turnstile_manage.vue"
// 平台票管理
import platform_ticket from "../views/ticket_system/platform_ticket.vue"

// 自助参数设置
// KTV参数设置
import KTV_params_set from "../views/self_service_set/KTV_params_set.vue";	
// 台球参数设置
import billiards_params_set from "../views/self_service_set/billiards_params_set.vue";
// 棋牌参数设置
import poker_params_set from "../views/self_service_set/poker_params_set.vue";
// 酒馆参数设置
import bar_params_set from "../views/self_service_set/bar_params_set.vue";


// 加页面记得添加属性
const pages = {
	index,
	login,
	index_content,
	employee_list,
	waiter_list,
	order_list,
	bill_list,
	book_order,
	pay_flow,
	book_list,
	package_name,
	package_price,
	timing_package,
	setting_package,
	actual_stock,
	deposit_manage,
	shipment_set,
	supplier_management,
	purchasing,
	procurement_return,
	stock_checks,
	store_getStoreList,
	store_getStoreProduceList,
	stock_getExchangeStockList,
	reported_loss,
	stock_receipts,

	store_list,
	store_set,
	store_set_business,
	store_set_bill,
	store_set_deposit,
	store_set_vod,
	store_set_store,
	store_set_print,
	store_set_personnel,
	store_set_system,
	// add_store,
	commodity_list,
	commodity_package_list,
	commodity_distribt,
	commodity_snack,
	price_strategy,
	point_exchange,
	self_roll_set,
	commodity_free_rule,
	flower_manage,
	commodity_must_order,
	printer_list,
	moling_set,
	zero_set,
	zoumadeng_set,
	members_send_info_set,
	set_rotation_song,
	vod_online_set,
	deposit_set,
	music_set,
	cash_register_set,
	movie_manage,
	refund_check,
	present_check,
	lack_song_set,
	room_type_set,
	welcome_template,
	repair_check,
	theme_menu_song,
	ad_space_set,
	vip_salon,
	pad_order_set,
	custom_music_manage,
	screen_ad_set,
	door_plate_set,
	guest_leave_store_apply_set,
	room_give_rule_set,
	welfare_activity,
	wx_order_home,
	performance_set,
	group_manage,
	// business_report,
	zm_report,
	zh_report,
	dm_report,
	dh_report,
	ys_report,
	xy_report,
	jls_report,
	jld_report,
	sjm_report,
	sjh_report,
	gzm_report,
	dym_report,
	dyh_report,
	bxf_report,
	balance_report,
	timefee_detail_report,
	wine_servicefee_report,
	balance_business_report,
	zxm_report,
	business_income_day_report,
	// store_report,
	sr_ksm_report,
	sr_ksh_report,
	sr_cgm_report,
	sr_cgh_report,
	sr_sym_report,
	sr_syh_report,
	sr_jxc_report,
	sr_pxm_report,
	// member_report,
	mr_hcz_report,
	mr_hbf_report,
	mr_hzl_report,
	mr_hkb_report,
	mr_hxm_report,
	mr_hsr_report,
	mr_yhx_report,
	mr_hcx_report,
	mr_hjm_report,
	mr_hjh_report,
	mr_ggzl_report,
	mr_ggky_report,
	mr_ggfm_report,
	mr_ggtm_report,
	mr_hjlm_report,
	mr_hjltm_report,
	mr_hlbgx_report,
	mr_yejz_report,
	mr_level_change_report,
	// Wine_access_report,
	war_jcm_report,
	war_jch_report,
	war_qjm_report,
	war_qjh_report,
	war_cgm_report,
	war_cgh_report,
	war_cqh_report,
	war_jcj_report,
	war_yqh_report,
	war_jczfm_report,
	// goods_sales_report,
	gsr_sxm_report,
	gsr_sxh_report,
	gsr_stm_report,
	gsr_sth_report,
	gsr_szh_report,
	gsr_stxm_report,
	gsr_stxh_report,
	gsr_ttxm_report,
	gsr_ttxh_report,
	gsr_szm_report,
	gsr_cph_report,
	gsr_ktxm_report,
	gsr_ktxh_report,
	gsr_smzm_report,
	// waiter_report,
	wr_ytkm_report,
	wr_ytc_report,
	wr_ytlh_report,
	wr_ybm_report,
	wr_ybh_report,
	wr_ydm_report,
	wr_ydh_report,
	wr_yzl_report,
	wr_ytpgm_report,
	wr_ytpsm_report,
	// others_report,
	or_hf_report,
	or_xld_report,
	or_kj_report,
	or_yg_report,
	or_fp_report,
	or_nff_report,
	or_kq_report,
	or_gdh_report,
	or_yxsm_report,
	or_jfdhm_report,
	or_jfdhh_report,
	or_kyjs_report,
	or_bpsm_report,
	or_dxfm_report,
	or_treasure_report,
	or_wx_login_report,
	or_song_month_report,
	// flower_report
	flower_detail_report,
	flower_total_report,
	// goods_profit_report
	profit_detail_report,
	profit_total_report,
	goodspackage_detail_report,
	goodspackage_total_report,
	kfpackage_detail_report,
	kfpackage_total_report,
	// ticket_sales_report
	tsr_mym_report,
	tsr_myh_report,
	tsr_gyh_report,
	tsr_pyh_report,
	tsr_tjsh_report,
	// customer_report
	customer_data_report,
	report_system_index,
	// 自助营业额报表
	turnover_report,
	// 自助营业收入报表
	operating_revenue_report,
	

	account_book_make,
	account_book_report,
	account_book_printer,

	ticket_manage,
	bistro_set,
	level_manage,
	race_manage,
	turnstile_manage,
	platform_ticket,
	// 自助参数设置
	KTV_params_set,
	billiards_params_set,
	poker_params_set,
	bar_params_set,
}
export default pages